import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, vModelRadio as _vModelRadio, vModelText as _vModelText, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6b6af9a8"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", { class: "solid my-4" }, null, -1));
const _hoisted_2 = { class: "section-title" };
const _hoisted_3 = { class: "required" };
const _hoisted_4 = { class: "send-limit__container" };
const _hoisted_5 = { class: "send-limit__input" };
const _hoisted_6 = { for: "nonofficial-automatic" };
const _hoisted_7 = { class: "send-limit__input" };
const _hoisted_8 = { for: "no_limit" };
const _hoisted_9 = {
    key: 0,
    class: "send-limit__container"
};
const _hoisted_10 = { class: "send-limit__daily" };
const _hoisted_11 = { class: "send-limit__balance" };
const _hoisted_12 = { class: "send-limit__balance-table" };
const _hoisted_13 = { class: "send-limit__balance-labels" };
const _hoisted_14 = { class: "send-limit__balance-label" };
const _hoisted_15 = { class: "send-limit__balance-label" };
const _hoisted_16 = { class: "send-limit__balance-label" };
const _hoisted_17 = { class: "send-limit__balance-values" };
const _hoisted_18 = { class: "send-limit__balance-value" };
const _hoisted_19 = { class: "send-limit__balance-number" };
const _hoisted_20 = { class: "send-limit__balance-value" };
const _hoisted_21 = { class: "send-limit__balance-number" };
const _hoisted_22 = { class: "send-limit__balance-value" };
const _hoisted_23 = { class: "send-limit__balance-number" };
const _hoisted_24 = {
    key: 1,
    class: "send-limit__container"
};
const _hoisted_25 = { class: "send-limit__container__text" };
import { computed } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CampaignsManagementSendLimit',
    setup(__props) {
        const store = useStore();
        const automaticAction = computed(() => store.state.campaignsManagement.automaticAction);
        const tooltipEmptyError = computed(() => store.state.campaignsManagement.tooltipEmptyError);
        const getNonOfficial = computed(() => {
            return store.getters.getNonOfficial;
        });
        const renewalDate = computed(() => {
            return moment(getNonOfficial.value.startDate).format('DD/MM/YY');
        });
        const usedBalance = computed(() => {
            return getNonOfficial.value.limit - getNonOfficial.value.balance;
        });
        const percentage = computed(() => {
            const value = (usedBalance.value / getNonOfficial.value.limit) * 100;
            return value.toLocaleString(store.getters.user?.language, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        });
        const computedSendLimit = computed({
            get: () => {
                return automaticAction.value.limitType;
            },
            set: newValue => {
                store.dispatch('campaignsManagement/setAutomaticAction', { name: 'limitType', value: newValue });
                if (newValue === 'no_limit') {
                    store.dispatch('campaignsManagement/setAutomaticAction', { name: 'limitValue', value: null });
                }
            },
        });
        const computedLimitValue = computed({
            get: () => {
                return automaticAction.value.limitValue;
            },
            set: newValue => {
                store.dispatch('campaignsManagement/setAutomaticAction', { name: 'limitValue', value: newValue });
            },
        });
        return (_ctx, _cache) => {
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _hoisted_1,
                _createElementVNode("h3", _hoisted_2, [
                    _createTextVNode(_toDisplayString(_ctx.$t('360.campaigns.details.send-limits.title')), 1),
                    _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_3, [
                        _createTextVNode("*")
                    ])), [
                        [
                            _directive_tooltip,
                            {
                                theme: 'error',
                                html: true,
                                autoHide: false,
                                distance: 8,
                                content: _ctx.$t('campaigns.required-section'),
                                shown: automaticAction.value.limitType === 'nonofficial-automatic' &&
                                    !automaticAction.value.limitValue &&
                                    tooltipEmptyError.value.limit,
                            },
                            void 0,
                            { right: true }
                        ]
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            value: "nonofficial-automatic",
                            id: "nonofficial-automatic",
                            name: "limit",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((computedSendLimit).value = $event))
                        }, null, 512), [
                            [_vModelRadio, computedSendLimit.value]
                        ]),
                        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('360.campaigns.details.send-limits.types.day')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            value: "no_limit",
                            id: "no_limit",
                            name: "limit",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((computedSendLimit).value = $event))
                        }, null, 512), [
                            [_vModelRadio, computedSendLimit.value]
                        ]),
                        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('360.campaigns.details.send-limits.types.no-limit')), 1)
                    ])
                ]),
                (computedSendLimit.value === 'nonofficial-automatic')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('360.campaigns.details.send-limits.daily')), 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "number",
                                placeholder: "Ex: 100",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((computedLimitValue).value = $event))
                            }, null, 512), [
                                [_vModelText, computedLimitValue.value]
                            ]),
                            _createElementVNode("small", null, _toDisplayString(_ctx.$t('360.campaigns.details.send-limits.daily-text')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.$t('360.campaigns.details.send-limits.send-balance')), 1),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('360.campaigns.details.send-limits.hired')), 1),
                                    _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('360.campaigns.details.send-limits.used')), 1),
                                    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('360.campaigns.details.send-limits.balance')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("p", _hoisted_18, [
                                        _createElementVNode("strong", _hoisted_19, _toDisplayString(getNonOfficial.value.limit), 1)
                                    ]),
                                    _createElementVNode("p", _hoisted_20, [
                                        _createElementVNode("strong", _hoisted_21, _toDisplayString(usedBalance.value) + " (" + _toDisplayString(percentage.value) + "%) ", 1)
                                    ]),
                                    _createElementVNode("p", _hoisted_22, [
                                        _createElementVNode("strong", _hoisted_23, _toDisplayString(getNonOfficial.value.balance), 1)
                                    ])
                                ])
                            ]),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('360.campaigns.details.send-limits.renews')) + " " + _toDisplayString(renewalDate.value), 1)
                        ])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('360.campaigns.details.send-limits.no-limit')), 1)
                    ]))
            ], 64));
        };
    }
});
